// src/services/apiClient.js
// Cliente HTTP centralizado para llamadas autenticadas.
// - Agrega el token Bearer automáticamente (no hay que repetirlo en cada componente).
// - Maneja 401 (sesión expirada/ inválida) en un solo lugar: limpia la sesión y
//   vuelve al inicio público, en vez de que cada vista falle distinto.
// Devuelve el Response nativo, así que el uso (res.ok / res.json()) no cambia.

// Normaliza la base: sin '/' final. Las rutas se pasan con '/api/...'.
export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000').replace(/\/+$/, '');

export async function apiFetch(path, options = {}) {
  const token   = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token && !headers.Authorization) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  // Sesión expirada/ inválida: cerrar sesión una sola vez y volver al inicio.
  if (res.status === 401 && token) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (!/\/(login|register)/.test(window.location.pathname)) {
      window.location.href = '/';
    }
  }
  return res;
}
